import React, { useEffect, useState, useMemo } from 'react'
import { Button, Badge, Text } from '@shopify/polaris'
import { useDispatch, useSelector } from 'react-redux'
import { setToast } from '../../store/slices/appSlice'
import { fulfillOrder, postManual } from '../../controller'
import { setOrders } from '../../store/slices/orderSlice';

const OrdersList = ({ loadingRow }) => {
    const orderReducer = useSelector((state) => state.order)
    const app = useSelector((state) => state.app)
    const dispatch = useDispatch()

    const [isFulfilled, setIsFulfilled] = useState({})
    const [isLoading, setIsLoading] = useState({})

    const formatDate = d => {
        if (d !== isNaN) {
            const date = new Date(d)
            date.setSeconds(0, 0);
            var stamp = date.toISOString().replace(/T/, " ").replace(/:00.000Z/, "");
            return stamp;
        }
    }

    const dataRows = []
    let i = 0
    if (orderReducer.list) {
        try {
            for (const item of orderReducer.list) {
                i += 1
                const order = item.orderJson
                if (Object.hasOwnProperty.call(order, "customer")) {
                    const first = order.shipping_address?.first_name ?? ""
                    const last = order.shipping_address?.last_name ?? ""
                    const address1 = order.shipping_address?.address1 ?? ""
                    const city = order.shipping_address?.city ?? ""
                    const zip = order.shipping_address?.zip ?? ""
                    const country = order.shipping_address?.country ?? ""
                    const badge = {
                        "status": item.orderPosted ? (item.fulfillmentStatus === "success" ? 'success' : "info") : 'critical',
                        "data": item.orderPosted ? (item.fulfillmentStatus === "success" ? 'Fulfilled' : "Posted") : 'Failed'
                    }

                    dataRows.push(<tr className={i % 2 === 0 ? "orderTableRows even" : "orderTableRows odd"} key={i}>
                        <td><a className='ex-link' href={`https://${app.store?.domain}/admin/orders/${item.orderId}`} title="See order details" target={'_blank'} rel="noreferrer">{order.name}</a></td>
                        <td>{isFulfilled.number ?? item.trackingNumber}</td>
                        <td>{formatDate(Date.parse(order.created_at))}</td>
                        <td>{first + " " + last}</td>
                        <td>{order.currency + " " + order.total_price + "/-"}</td>
                        <td>{address1 + ", " + city + " " + zip + ", " + country}</td>
                        <td><Badge status={badge.status}>{badge.data}</Badge></td>
                        <td>{item.orderPosted ? <Button
                            fullWidth
                            primary
                            disabled={isFulfilled[order.order_number] || item.fulfillmentStatus === "success" || isLoading[order.order_number]}
                            loading={isLoading[order.order_number]}
                            onClick={async () => {
                                setIsLoading({ ...isLoading, [order.order_number]: true })
                                const response = await fulfillOrder(order.order_number, app.store.shopId)
                                setIsFulfilled({ ...isFulfilled, [order.order_number]: response.success && response.data?.fulfillment.status === "success" })
                                dispatch(setToast({ active: true, content: response.message, error: !response.success }))
                                setIsLoading({ ...isLoading, [order.order_number]: false })
                            }}>
                            Check Tracking
                        </Button> : <Button
                            fullWidth
                            primary
                            loading={isLoading[order.order_number]}
                            disabled={isLoading[order.order_number]}
                            onClick={async () => {
                                setIsLoading({ ...isLoading, [order.order_number]: true })
                                const response = await postManual(order.order_number, app.store.shopId)
                                if (Object.hasOwnProperty.call(response, "order")) {
                                    let index = null
                                    const orderList = [...orderReducer.list]
                                    for (let i = 0; i < orderReducer.list.length; i++) {
                                        const o = orderReducer.list[i];
                                        if (o.orderNumber.toString() === order.order_number.toString()) {
                                            index = i
                                        }
                                    }
                                    orderList.splice(index, 1, response.order)
                                    dispatch(setOrders(orderList))
                                }
                                dispatch(setToast({ active: true, content: response.message, error: !response.success }))
                                setIsLoading({ ...isLoading, [order.order_number]: false })
                            }}
                        >
                            Post Order
                        </Button>}</td>
                    </tr>)
                }
            }
        } catch (error) {
            console.log(error.message)
        }
    }
    return (
        dataRows
    )
}

export default OrdersList